export default __webpack_public_path__ + "static/media/Dr._Mihaela_Ulieru_AHV_In_Moms_We_Trust.31cb36ba.jpg";